<template>
  <div class="promo-card popup">
    <div class="promo-card__card bg-white">
      <div class="promo-card__actions">
        <div>
          <a-select :value="selectedLanguage" size="small" @change="handleLangChange" class="lang-select">
            <a-select-option v-for="lang in langOptions" :key="lang.value">
              {{ lang.name }}
            </a-select-option>
          </a-select>
        </div>
        <div>
          <a-button type="link" :disabled="!editPermission" @click="openEditPage"><a-icon type="edit"
              class="text-primary font-size-16" />Edit</a-button>
        </div>
        <!-- <a-checkbox v-if="isViewscreen" :checked="addToViewscreen" :disabled="isCheckboxDisabled" @change="handleViewscreenChange"/> -->
      </div>
      <div class="promo-card__content" @click="openFullInfoModal">
        <div class="promo-card__main">
          <div>
            <img class="promo-card__image" :src="selectedImage.path" alt="" />
          </div>
          <div class="promo-card__left">
            <div class="mb-2">
              <div class="promo-card--title">Name (for internal usage)</div>
              <span class="promo-card-title promo-card--text">{{ popupContext.name }}</span>
            </div>
            <div class="mb-2">
              <div class="promo-card--title">Title</div>
              <span class="promo-card-title promo-card--text">{{ stripHtml(selectedInfo.title) }}</span>
            </div>
            <div class="mb-2">
              <div class="promo-card--title">Section</div>
              <div v-if="Array.isArray(popupContext.displays) && popupContext.displays.length"
                style="line-height: 1.8rem">
                <a-tag class="info-modal--tag" v-for="display in popupContext.displays" :key="display.id">
                  {{ displays[display.id] }}
                </a-tag>
              </div>
              <div v-else>-</div>
            </div>
            <div>
              <div class="promo-card--title">Apps</div>
              <div style="line-height: 2.1rem">
                <a-tag style="margin-right: 15px; padding: 1px 8px; border-radius: 2px"
                  v-for="app in popupContext.applications.slice(0, 1)" :key="app.id">
                  {{ app.name }}
                  <a-icon v-if="app.platform.toLowerCase() === 'android'" type="android" class="ml-1 text-success" />
                  <a-icon v-if="app.platform.toLowerCase() === 'ios'" type="apple" class="ml-1 text-primary" />
                  <a-icon v-if="app.platform.toLowerCase() === 'web'" type="global" class="ml-1 text-default" />
                </a-tag>
                <a-tag v-if="popupContext.applications.length > 1">
                  ...
                </a-tag>
              </div>
            </div>
          </div>
        </div>
        <div v-if="popupContext.periods">
          <div class="promo-card--title">Show Period</div>
          <div style="line-height: 2.1rem">
            <a-tag style="padding: 1px 8px; border-radius: 2px"
              v-for="period in popupContext.periods.slice(0, 1)" :key="period.starts_at">
              {{ `${formatDate(period.starts_at)} - ${formatDate(period.ends_at)} ${formatTimezone(period.time_mode)}` }}
            </a-tag>
            <a-tag v-if="popupContext.periods.length > 1" style="padding: 1px 8px; border-radius: 2px">
              {{ `+${popupContext.periods.length - 1}` }}
            </a-tag>
          </div>
        </div>
      </div>
      <div class="promo-card__footer">
        <div class="d-flex align-items-center" :class="{ 'promo-card__footer--inf': !firstPeriodStart }">
          <div class="text-uppercase mr-auto">
            <span v-if="firstPeriodStart">
              {{ formatDate(firstPeriodStart) }} -
            </span>
            <span v-if="lastPeriodEnd">
              {{ formatDate(lastPeriodEnd) }}
            </span>
            <span v-else style="font-size: 20px;">&infin;</span>
          </div>
          <div class="d-flex">
            <a-switch :default-checked="popupContext.is_active" @change="popupActiveSwitch"
              :disabled="!editPermission" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import apiClient from '@/services/axios'
import MediaService from '@/services/api/apiMediaService'

import { formatTimezone } from '@/services/utils/media'

export default {
  name: 'Popup-card',
  components: { },
  props: {
    popupInfo: {
      type: Object,
    },
    editPermission: {
      type: Boolean,
    },
    languages: {
      type: Array,
    },
    displays: {
      type: Object,
    },
  },
  data: () => ({
    selectedLanguage: 'ru',
    addToViewscreen: false,
  }),
  computed: {
    popupContext() {
      return this.popupInfo.context
    },
    selectedInfo() {
      return this.popupContext.images[this.selectedLanguage]
    },
    selectedImage() {
      return this.selectedInfo.image
    },
    langOptions() {
      const langKeys = Object.keys(this.popupContext.images)
      return this.languages.filter(language => langKeys.includes(language.name)).map(language => ({
        name: language.desc,
        value: language.name,
      }))
    },
    firstPeriodStart() {
      if (!this.popupContext?.periods?.length) {
        return null
      }

      return this.popupContext.periods[0].starts_at
    },
    lastPeriodEnd() {
      if (!this.popupContext?.periods?.length) {
        return null
      }

      const lastIndex = this.popupContext.periods?.length - 1

      return this.popupContext.periods[lastIndex].ends_at
    },
  },
  watch: {
  },
  created() {
    if (this.langOptions.length) {
      this.selectedLanguage = this.langOptions[0].value
    }
  },
  methods: {
    formatTimezone,
    openFullInfoModal() {
      this.$emit('openFullInfo')
    },
    openEditPage() {
      this.$emit('openEdit')
    },
    formatDate: function (date) {
      return this.$moment(date).format('DD.MM.YY HH:mm')
    },
    handleLangChange(selectedLangKey) {
      this.selectedLanguage = selectedLangKey
    },
    stripHtml(htmlString) {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = htmlString

      return tempDiv.textContent || tempDiv.innerText || ''
    },
    // handleViewscreenChange(event) {
    //   this.addToViewscreen = event.target.checked
    //   const action = event.target.checked ? 'addToViewscreenArray' : 'deleteFromViewscreenArray'
    //   this.$emit(action, this.popupInfo.id)
    // },
    async popupActiveSwitch(checked) {
      try {
        const popupPayload = {
          is_active: checked,
        }
        const popupResponse = await MediaService.updatePopup(this.popupContext.id, popupPayload)
        this.$notification.success({
          message: 'Active status changed',
          description: `${this.popupContext.name} status have been changed`,
        })
        if (popupResponse?.data?.error || popupResponse.data.success === false || popupResponse.data.error) {
          const errorMessage =
            popupResponse.data.error?.message ||
            'Something went wrong while updating popup activity'
          this.$notification.error({
            message: errorMessage,
          })
          this.loading = false
          return
        }
      } catch (e) {
        const errorMessage =
          e.response.data?.error?.message ||
          'Something went wrong while updating activity'
        this.$notification.error({
          message: errorMessage,
        })
      }
    },
  },
}
</script>

<style lang="scss" src="../style.module.scss" />
